<template>
	<div class="wrong-google-email-dialog flex-centerize flex-column">
		<QuestionMarkEnvelopeSVG />

		<div class="title-text">
			Seems like the Google account you’re trying to connect isn’t the same as the email you received the invite to.
		</div>
		<br />
		<div class="content-text">
			Complete the sign up with a password or use the Google account associated with the email account that was invited.
		</div>
		<v-btn class="btn btn-primary" @click="$emit('onConfirm')"> Got it </v-btn>
	</div>
</template>

<script>
import QuestionMarkEnvelopeSVG from './assets/QuestionMarkEnvelopeSVG';

export default {
	name: 'WrongGoogleEmailDialog',
	components: {
		QuestionMarkEnvelopeSVG,
	},
};
</script>

<style scoped lang="scss">
.wrong-google-email-dialog {
	color: #3e495a;
	max-width: 492px;
	border-radius: 8px;
	text-align: center;
	padding: 36px 45px;
	background-color: var(--dialog-bg);
	box-shadow: 0px 5px 49px #0000005c;

	.title-text {
		font-size: 16px;
		margin-top: 20px;
		font-weight: 600;
	}

	.content-text {
		font-size: 14px;
		font-weight: 300;
	}
	.btn {
		width: 220px;
		margin-top: 35px !important;
		border-radius: 3px !important;
	}
}
</style>
